<template>
  <div>
    <div v-if="videos != null">
      <div id="convert-result" class="results form__results_block_result">
        <div class="results__container">
          <div class="results__info">
            <img class="results__image" :src="thumb" :alt="meta.title">
            <h4 class="results__title">{{ meta.title }}</h4>
          </div>
          <div class="results__options">
            <div v-if="isYoutube && !isYoutubeToMP3" class="results__tabs">
              <button
                class="results__tab"
                v-bind:class="{ 'results__tab_active': !audioTabActive }"
                type="button"
                @click="audioTabActive = false"
              >
                <img v-if="audioTabActive === true" src="/images/form/video-inactive.svg">
                <img v-else src="/images/form/video-active.svg">
                <span>Video</span>
              </button>
              <button
                class="results__tab"
                v-bind:class="{ 'results__tab_active': audioTabActive }"
                type="button"
                @click="audioTabActive = true"
              >
                <img v-if="audioTabActive === true" src="/images/form/audio-active.svg">
                <img v-else src="/images/form/audio-inactive.svg">
                <span>Audio</span>
              </button>
            </div>
            <table class="results__table" cellspacing="0">
              <thead class="results__table-header">
                <tr>
                  <th class="results__table-cell" scope="col">File type</th>
                  <th class="results__table-cell" scope="col">File size</th>
                  <th class="results__table-cell results__table-column-action" scope="col">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody v-if="!audioTabActive">
                <tr v-for="(video) in videosList" :key="video.url">
                  <td class="results__table-cell">
                    <div class="results__table-cell-cover">
                      <p class="results__table-cell-text">
                        <span
                          class="results__table-cell-text results__table-cell-text_alt"
                        >
                          {{ video.ext }}
                        </span>
                        {{ video.quality }}
                      </p>
                      <img
                        v-if="video.no_audio"
                        src="/images/form/mute.svg"
                        alt="mute"
                        width="16px"
                        height="16px"
                      >
                    </div>
                  </td>
                  <td class="results__table-cell" >
                    <p class="results__table-cell-text results__table-cell-text_alt">
                      {{ getFilesize(video.filesize) }}
                    </p>
                  </td>
                  <td class="results__table-cell results__table-column-action">
                    <a
                      class="results__btn-download"
                      @click="download(video.url, meta.title + video.ext, video.ext, video)"
                    >
                      <img
                        src="/images/form/arrow-down.svg"
                        alt="arrow down"
                        width="16px"
                        height="16px"
                      >
                      <p>Download</p>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="audioTabActive && audios">
                <tr v-for="(audio) in audiosList" :key="audio.url">
                  <td class="results__table-cell">
                    <div class="results__table-cell-cover">
                      <p class="results__table-cell-text">
                        <span
                          class="results__table-cell-text results__table-cell-text_alt"
                        >
                          {{ audio.ext }}
                        </span>
                        {{ audio.quality }}
                      </p>
                    </div>
                  </td>
                  <td class="results__table-cell" >
                    <p class="results__table-cell-text results__table-cell-text_alt">
                      {{ getFilesize(audio.filesize) }}
                    </p>
                  </td>
                  <td class="results__table-cell results__table-column-action">
                    <a
                      class="results__btn-download"
                      @click="download(audio.url, meta.title + audio.ext, audio.ext)"
                    >
                      <img
                        src="/images/form/arrow-down.svg"
                        alt="arrow down"
                        width="16px"
                        height="16px"
                      >
                      <p>Download</p>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <button
              class="results__show-more"
              @click="showMore = !showMore"
              v-if="
                (!audioTabActive && videos.length > listDefaultLength) ||
                (audioTabActive && audios.length > listDefaultLength)
              "
            >
              <span>{{ showMore ? "Show less" : "Show more" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="videos === null && manyElements !== null">
      <div class="results results_theme_many-elems form__results_block_result">
        <div
          class="results__video-container"
          v-for="manyElement in manyElements"
          :key="manyElement.url[0].url"
        >
          <img
            class="results__image results__image_alt"
            :src="manyElement.thumb"
            :alt="manyElement.meta.title"
          >
          <div class="results__description-block">
            <h4 class="results__title">{{ manyElement.meta.title }}</h4>
            <p v-if="manyElement.meta.duration" class="results__text">
              Duration: {{ manyElement.meta.duration }}
            </p>
            <p v-if="manyElement.title" class="results__text">
              {{ manyElement.title }}
            </p>
          </div>
          <button
            type="button"
            class="results__btn-download"
            @click.prevent="sendToForm(manyElement.url[0].url)"
            @click="download(
              manyElement.url[0].url,
              manyElement.meta.title + manyElement.ext,
              manyElement.ext
            )"
          >
            <img
              src="/images/form/arrow-down.svg"
              alt="arrow down"
              width="16px"
              height="16px"
            >
            <p>Download</p>
          </button>
        </div>
      </div>
    </div>
    <div v-if="error">
      <ErrorBlock :label="label" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ErrorBlock from "./ErrorBlock";
import { showConverterUIPopup } from "../tools/showConverterUIPopup";

export default {
  components: {
    ErrorBlock
  },
  name: 'MainResults',
  props: {
    activBtn: String,
    searchUrlInsPosts: String,
    searchUrlInsStories: String,
  },
  data() {
    return {
      videos: null,
      meta: null,
      link: null,
      thumb: null,
      audios: [],
      error: null,
      audioTabActive: false,
      showMore: false,
      listDefaultLength: 4,
      manyElements: null,
      linkStories: null,
      linkPosts: null,
      rootOnSearchResults: false,
      label: '',
      requestStartDate: 0,
      isYoutube: false,
      isYoutubeToMP3: false
    }
  },
  mounted() {
    this.isYoutube = false;
    this.isYoutubeToMP3 =
      window?.location.pathname?.includes('youtube-to-mp3') ||
      window?.location?.href.includes('youtube-to-mp3');
    this.$root.$on('clear-results', () => {
      this.videos = null;
      this.meta = null;
      this.thumb = null;
      this.audios = [];
      this.error = null;
      this.audioTabActive = false;
      this.showMore = false;
      this.link = null;
      this.rootOnSearchResults = false;
      this.manyElements = null;
    });
    this.$root.$on('link-submit', (link) => {
      document.getElementById('main-form').scrollIntoView();
      this.link = link;
      this.request(link);
    });
    if (this.activBtn) {
      document.getElementById('main-form').scrollIntoView();

      if (this.activBtn === 'posts' && this.searchUrlInsPosts) {
        this.$root.$emit('link-submit-posts', this.searchUrlInsPosts)
        this.linkPosts = this.searchUrlInsPosts;
        this.manyElements = null
        this.rootOnSearchResults = true;
        if (this.linkPosts && this.linkStories !== this.linkPosts) {
          this.request(this.linkPosts);
        }
      }
      if (this.activBtn === 'stories' && this.searchUrlInsStories) {
        this.$root.$emit('link-submit-stories', this.searchUrlInsStories)
        this.linkStories = this.searchUrlInsStories;
        this.manyElements = null;
        this.rootOnSearchResults = true;
        if (this.linkStories && this.linkStories !== this.linkPosts) {
          this.request(this.linkStories);
        };
      }
    }
  },
  methods: {
    handleError(result) {
      this.$root.$emit('show-error', result, this.link);
      this.$root.$emit('send-error-time', this.requestStartDate, this.link);
      this.error = true;
    },
    async request(link) {
      this.requestStartDate = Date.now();
      document.getElementById('loader').style.display = null;
      const statusState = { status: false };
      if (statusState.status) return;

      const signedBody = await this.$root.subscribeSignedRequestBody(link.replace('?source=search', ''));
      const body = this.isYoutubeToMP3
        ? {
            ...signedBody,
            converter: 'ffmpeg-mp3',
          }
        : signedBody;

      axios.post('/api/convert', body, {
        timeout: 45000
      }).then((success) => {
        const dataExt = this.isYoutubeToMP3 ? 'mp3' : 'mp4';
        if (success.data?.length > 1 && success.data[1].url) {
          this.$root.$emit('show-results', success.data[0], this.link, dataExt);
          return this.manyElements = success.data
        }
        if (!success.data.length && this.activBtn) {
          this.label = 'It seems that there are no stories for the last 24 hours'
          return this.handleError(this.label, this.link)
        }

        if (success.data && success.data.blacklist) return this.handleError(success.data, this.link);
        this.$root.$emit('show-results', success.data, this.link, dataExt);
        this.videos = removeDuplicates(success.data.url.filter((item) => item.audio != true));
        this.videos.sort((a, b) => {
          if (!a.no_audio && b.no_audio) {
            return -1;
          } else if (a.no_audio && !b.no_audio) {
            return 1;
          }
          const aq = parseInt(a.quality);
          const bq = parseInt(b.quality);
          return aq < bq ? 1 : -1;
        });
        this.audios = success.data.url.filter((item) => item.audio === true);
        this.meta = success.data.meta;
        this.thumb = success.data.thumb;
        window.videos = this.videos;
        this.isYoutube = body.url.includes('youtu');
      }).catch((e) => {
        if(e.response.status >= 400) {
          if(e.response.status === 401) {
            this.label = e.response.data.error_message;
            this.handleError(e.response, this.link);
            return;
          } else {
            this.label = 'The download link was not found';
            this.handleError(e.response, this.link);
            return;
          }
        }
        let result = e.code == "ECONNABORTED" ? { timeout: true } : e.response && e.response.data;
        this.handleError(result, this.link);
      }).finally(() => {
        document.getElementById('loader').style.display = "none";

        this.$root.$emit('result-end');
      });
    },
    download(link, download, ext, videoObj) {
      if (videoObj?.isConverterUI) {
        const gaResource = 'G-ENFGPRNF80';
        const adsGaResource = 'G-ENFGPRNF80';

        if (window.gtag) {
          window.gtag('event', 'converter_link_click', {
            send_to: gaResource,
          });
        }

        showConverterUIPopup(
          videoObj?.url,
          '#ff1757',
          '', //! no clickAds url
          {
            gaResource,
            adsGaResource,
          }
        );

        return;
      }

      this.$root.$emit('download-click', this.link, ext);
      setTimeout(() => {
        document.location = link;
      }, 500);
    },
    convert() {
      return this.$root.$emit('convert-link', this.link);
    },
    getFilesize(size) {
      if (!size) return 'unknown';

      const units = ['b', 'kb', 'mb', 'gb', 'tb'];
      let filesize = size;
      let i = 0;

      while(filesize > 1023) {
        if (i === units.length - 1) break;
        filesize /= 1024;
        i++;
      }

      return `${(Math.round(filesize * 10) / 10)} ${units[i]}`;
    }
  },
  computed: {
    videosList() {
      return this.showMore ? this.videos : this.videos.slice(0, this.listDefaultLength)
    },
    audiosList() {
      return this.showMore ? this.audios : this.audios.slice(0, this.listDefaultLength)
    },
  }
}

function removeDuplicates(videos) {
  const unique = new Set();
  return videos.filter((item) => {
    const key = item.quality + item.ext + item.no_audio;
    const duplicate = unique.has(key);
    unique.add(key);
    return !duplicate;
  });
}

</script>
